import { FileUploader } from "react-drag-drop-files";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Dispatch, SetStateAction, useState } from "react";
import { FilledInput, Typography } from "@mui/material";
import axios from "axios";
import PreviewUpload from "./PreviewUpload";
import IResponse from "../../interfaces/response";
import IFile from "../../interfaces/file";

interface IProps {
    type?: 'image' | 'video' | 'media' | 'file',
    text: string,
    multiple?: boolean,
    setUrls: Dispatch<SetStateAction<IFile[]>>,
    defaultUrls?: IFile[],
    className?: string
}

const typesFile = {
    image: ["jpg", "png", "jpeg", "webp", "jfif"],
    video: ["mp4"],
    media: ["jpg", "png", "jpeg", "webp", "jfif", "mp4"],
    file: undefined
}

export default function Upload({ type = 'image', text, multiple = false, setUrls, defaultUrls, className=''}: IProps) {
    const [files, setFiles] = useState<{ file: File, loaded: number }[]>([]);

    const handleChange = (file: File | FileList) => {
        const newFiles = file instanceof File ? [file] : [...file];
        const length = files.length;
        setFiles(old => [...old, ...newFiles.map(f => ({ file: f, loaded: 0 }))]);
        newFiles.forEach((f, index) => {
            const data = new FormData();
            data.append("file", f);
            axios<IResponse<IFile>>({
                url: "/storage/upload",
                method: "POST",
                onUploadProgress: (e) => {
                    if (e.total) {
                        const percentage = Math.round((e.loaded * 100) / e.total)
                        setFiles(old => {
                            const newFiles = [...old];
                            newFiles[index + length].loaded = percentage;
                            return newFiles;
                        })
                    }
                },
                data,
            }).then(res => {
                if (res.data.success) {
                    const url = res.data.data
                    if (multiple) {
                        setUrls(old => [...old, url]);
                    } else {
                        setUrls([url]);
                    }
                }
            })
        })
    }

    return (
        <FileUploader
            multiple={multiple}
            classes={`border-dashed border border-action-active rounded p-2 pt-6 h-32 relative bg-primary-hover overflow-hidden ${className}`}
            handleChange={handleChange}
            component={<FilledInput />}
            name="file"
            maxSize={1000}
            minSize={0}
            types={typesFile[type]}>
            {
                files.length || defaultUrls?.length ?
                    <div className={`flex flex-row items-center w-full justify-center gap-2 text-text-secondary`}>
                        <CloudUploadIcon />
                        <Typography className="text-sm">{text}</Typography>
                    </div>
                    :
                    <div className={`center w-full flex flex-col items-center justify-center gap-1 text-text-secondary `}>
                        <CloudUploadIcon />
                        <Typography className="">{text}</Typography>
                    </div>
            }
            <div className="flex gap-2 justify-center min-h-14 mt-4 overflow-x-auto">
                {
                    defaultUrls?.filter(file => file.url.startsWith('http'))
                        .map((file, index) => <PreviewUpload key={index} type={type} url={file.url} />)
                }
                {
                    files.map((file, index) => <PreviewUpload key={index} type={type} file={file.file} loaded={file.loaded} />)
                }
            </div>
        </FileUploader>
    )
}
